var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38342 4H3.05009C2.6819 4 2.38342 4.29848 2.38342 4.66667V13.3333C2.38342 13.7015 2.6819 14 3.05009 14H11.7168C12.0849 14 12.3834 13.7015 12.3834 13.3333V9.41667",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41345 9.30901C6.21819 9.50427 6.21819 9.82085 6.41345 10.0161C6.60871 10.2114 6.92529 10.2114 7.12056 10.0161L6.41345 9.30901ZM13.5903 2.83923L14.0903 2.83923L14.0903 2.33923L13.5903 2.33923L13.5903 2.83923ZM13.0904 6.69199C13.0904 6.96814 13.3142 7.19199 13.5904 7.19199C13.8665 7.19199 14.0904 6.96813 14.0904 6.69199L13.0904 6.69199ZM9.56533 2.33923C9.28919 2.33923 9.06533 2.56309 9.06533 2.83923C9.06533 3.11538 9.28919 3.33923 9.56533 3.33923V2.33923ZM7.12056 10.0161L13.9439 3.19279L13.2368 2.48568L6.41345 9.30901L7.12056 10.0161ZM13.0903 2.83924L13.0904 6.69199L14.0904 6.69199L14.0903 2.83923L13.0903 2.83924ZM13.5903 2.33923L9.56533 2.33923V3.33923L13.5903 3.33923L13.5903 2.33923Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutLink);
export default __webpack_public_path__ + "static/media/out-link.ffacdd71.svg";
export { ForwardRef as ReactComponent };